import Vector2 from "../../math/Vector2";
import Color from "../../util/Color";
import { Random } from "../../util/Random";
import SPBogey from "../SPBogey";
import SPPlayer from "../SPPlayer";
import Worm from "./Worm";

export default class WormMaster extends SPBogey {

    segments = 10;

    segmentRefs: Worm[] = [];

    register(segment: Worm) {
        this.segmentRefs.push(segment);
    }

    unregister(segment: Worm) {
        const index = this.segmentRefs.indexOf(segment);
        if (index < 0) return;

        this.segmentRefs.splice(this.segmentRefs.indexOf(segment), 1);
    }

    

    Die(crashedIntoPlayer?: boolean): void {
        if (this.isDead) return;
        super.Die(crashedIntoPlayer);

        for (let i = 0; i < this.segmentRefs.length; i++) {
            const ref = this.segmentRefs[i];
            setTimeout(() => {
                ref.Die(crashedIntoPlayer);
            }, i * 100);
        }
    }

    Start(): void {
        this.engine.NewGameObjectWithScript(Worm, {
            position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460)),
            initialValues: {
                xpReward: this.xpReward,
                fireRate: this.fireRate,
                size: this.size,
                hp: this.hp,
                maxHP: this.maxHP,
                isHead: true,
                master: this,
                initialSegments: this.segments,
                color: new Color(212,179,91)
            }
        });

        this.xpReward = 0;
        this.hp *= this.segments;
        this.maxHP = this.hp;

    }

    Update(): void {
        
    }

}